import React from 'react';
import { Link } from 'react-router-dom';
import CommonPageHeader from '../../components/CommonPageHeader/CommonPageHeader';
import Footer from '../../components/Shared/Footer';
import HomeHeader from '../Home/Home/HomeHeader/HomeHeader';
import { useTranslation } from 'react-i18next';
import SEOHead from '../../components/SEO/SEOHead';

const NotFound = () => {
  const { t, i18n } = useTranslation();
  return (
    <>
      <SEOHead
        title={i18n.language === 'en' ? '404 | Page Not Found' : '404 | Sayfa Bulunamadi'}
        description={i18n.language === 'en'
          ? 'The page you are looking for could not be found. Return to the homepage of Assoc. Prof. Dr. Ebru Karagün.'
          : 'Aradiginiz sayfa bulunamadi. Doç. Dr. Ebru Karagün ana sayfasina geri donebilirsiniz.'}
        image="/img/about/drebrukaragun.jpg"
        imageAlt={i18n.language === 'en'
          ? 'Portrait of Assoc. Prof. Dr. Ebru Karagün'
          : 'Doç. Dr. Ebru Karagün portre fotografi'}
        noindex={true}
      />
      <HomeHeader />
      <CommonPageHeader title={`${t('notFoundPage.header')}`} subtitle={`404 ${t('notFoundPage.header')}`} />

      <div className='pt-120 pb-120'>
        <div className='container'>
          <div className='row'>
            <div className='col-xl-8 offset-xl-2'>
              <div className='error-404 not-found mb-20'>
                <div className='error-404-content text-center'>
                  <h1 className='error-404-title'> 404 </h1>
                  <h2 className='error-title'>{t('notFoundPage.header')}</h2>
                  <p className='err-text'>{t('notFoundPage.description')} </p>
                  <Link to={i18n.language === 'en' ? "/en/" : "/"} className="primary_btn btn-icon ml-0"><span>{'>'}</span>{t('notFoundPage.mainPage')}</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default NotFound;
